import angular from "angular";
import panel from "../services";

function questionsChemistry (panel) {

    return {
        restrict: 'E',
        scope: {
            questions: '='
        },
        link: function(scope) {
        },
        template: require('./templates/questions-chemistry.html')
    }
};

export default angular.module('directives.questionsChemistry', [panel]).directive('questionsChemistry', questionsChemistry).name;


// WEBPACK FOOTER //
// ./src/app/directives/questionsChemistry.js